import FileSaver from 'file-saver';
import CountUp from 'react-countup';
import * as Session from './session';
import crypto from './crypto';

const Utils = {
  // 通过字节数拿到字符串索引
  getCharIndexByBytes(str, maxBytes) {
    const encoder = new TextEncoder();
    let totalBytes = 0;
    let index = 0;

    for(const char of str) {
      const charBytes = encoder.encode(char).length;
      if(totalBytes + charBytes > maxBytes) break;
      totalBytes += charBytes;
      index++;
    }

    return index;
  },
  /** 按比例缩略显示图片 */
  thumbImage(url, rate = 50) {
    return url + '?x-oss-process=image/resize,p_' + rate;
  },
  /**
   * Flat Map 根据相应的字断
   * @param arr 源数组
   * @param step 层级
   * @param clear 是否删除原层级数据
   * @returns {[]|*[]}
   */
  flatMap(arr, step = 'children', clear = false) {
    const flatArr = [];
    const iterate = function(item) {
      flatArr.push(item);
      if(item[step]) {
        item[step].forEach(v => {
          iterate(v);
        });
        if(clear) {
          delete item[step];
        }
      }
    };
    if(!arr || !(arr instanceof Array)) {
      return [];
    } else {
      arr.forEach(iterate);
      return flatArr;
    }
  },
  encrypt(data, key = '50525c3fbe3b9218') {
    return crypto.aesEncrypt(data, key);
  },
  decrypt(data, key = '50525c3fbe3b9218') {
    return crypto.aesDecrypt(data, key);
  },
  /**
   * unFlat Map 根据相应的字断
   * @param items 扁平数组
   * @param key 父类id key
   * @param parentId 父类id key
   * @param child 子类 key
   * @returns {[]}
   */
  unFlatMap(items, key = 'id', parentId = 'parentId', child = 'children') {
    const result = [];   // 存放结果集
    const itemMap = {};  //
    for(const item of items) {
      const id = item[key];
      const pid = item[parentId];

      if(!itemMap[id]) {
        itemMap[id] = { [child]: [] };
      }

      itemMap[id] = { ...item, [child]: itemMap[id][child] };

      const treeItem =  itemMap[id];

      if(pid === 0) {
        result.push(treeItem);
      } else {
        if(!itemMap[pid]) {
          itemMap[pid] = { [child]: [] };
        }
        itemMap[pid][child].push(treeItem);
      }
    }
    return result;
  },

  params2json(params = '', slice = '&') {
    return params.split(slice).reduce((acc, item) => {
      let arr = item.split('=');
      return item ? { ...acc, ...{ [arr[0]]: arr[1] }} : acc;
    }, {});
  },

  handlerOptions(option, textKey, valueKey) {
    if(!option) throw new Error('option can not be undifend or null');
    const optionProps = {};
    if(typeof option === 'object') {
      optionProps.disabled = option.disabled || false;
      option = {
        [textKey]: option[textKey],
        [valueKey]: option[valueKey]
      };
    } else {
      option = { [textKey]: option, [valueKey]: option };
    }
    return { option, optionProps };
  },
  getFileExt(fileName = '') {
    const index = fileName.lastIndexOf('.');
    const regExp = new RegExp('^[A-Za-z0-9]+$');
    if(index > 0 && regExp.test(fileName.slice(index + 1))) {
      fileName = fileName.toLowerCase();
      return fileName.substring(index + 1);
    }
    return '';
  },
  // 导出文件
  exportFile(url = '', name = '') {
    if(!url) return;
    const format = Utils.getFileExt(url);
    return FileSaver.saveAs(url, `${`${name.replace('.' + format, '')}`.trim()}.${format}`);
  },

  isNotEmpty(value) {
    switch (typeof value) {
      case 'undefined': {
        return false;
      }

      case 'string': {
        return value.length !== 0;
      }

      case 'object': {
        if(Array.isArray(value)) {
          return value.length !== 0;
        } else if(value === null) {
          return false;
        } else {
          return Object.keys(value).length !== 0;
        }
      }

      default: {
        return true;
      }
    }
  },

  //保留搜索页
  checkSearchOptions(searchOptions) {
    const pathname = window.location.pathname;
    const sessionKey = `${pathname}-searchOptions`;
    if(Session.get(sessionKey)) {
      return JSON.parse(Session.get(sessionKey));
    } else {
      return Session.put(sessionKey, JSON.stringify(searchOptions));
    }
  },

  //保留搜索页
  /**
   * 传了searchOptions就会存储，不传就是读取
   * @param searchOptions
   * @returns {any|void}
   */
  checkSearchOptions1(searchOptions) {
    const pathname = window.location.pathname;
    const sessionKey = `${pathname}-searchOptions`;
    if(searchOptions) {
      return Session.put(sessionKey, JSON.stringify(searchOptions));
    } else if(Session.get(sessionKey)) {
      return JSON.parse(Session.get(sessionKey || '{}'));
    }
  },

  searchAssign(origin = {}, values = {}, ...params) {
    let tempValue = Object.assign({}, values);
    if(params && params.length) {
      params.forEach((item) => {
        Object.assign(tempValue, item);
      });
    }
    if(Object.keys(tempValue).length) {
      for(let key in tempValue) {
        if(this.isNotEmpty(tempValue[key]) && this.isNotEmpty(String(tempValue[key]))) {
          origin[key] = tempValue[key];
        } else {
          delete origin[key];
        }
      }
    } else {
      for(let key in origin) {
        if(!this.isNotEmpty(origin[key])) {
          delete origin[key];
        }
      }
    }
    return origin;
  },

  /**
   * 先过滤对象中的空属性，再合并，使用方法类似于Object.assign，不对第一个参数做修改，而是将结果作为新的对象返回
   * @param args
   * @returns {{}}
   */
  filterMerge(...args) {
    return Object.assign.apply(null, args.map((object) => {
      return Object.keys(object).reduce((obj, key) => {
        const value = object[key];
        if(Utils.isNotEmpty(value) && value !== 'undefined') {
          obj[key] = value;
        }
        return obj;
      }, {});
    }));
  },

  json2params(json, slice = '&') {
    return Object.keys(json).reduce((acc, item) => {
      return String(acc) + item + '=' + json[item] + slice;
    }, '').slice(0, -1);
  },

  formatQuery2QueryStr(query = {}) {
    let queryStr = '';
    const filteredQuery = Utils.filterMerge(query);
    if(Utils.isNotEmpty(filteredQuery)) {
      queryStr = '?' + Utils.json2params(filteredQuery);
    }
    return queryStr;
  },

  /**
   * 链接拼参数
   * @param url 可以是带query的也可以是不带的
   * @param params 拼的参数对象
   * @returns {string}
   */
  padQuery(url = '', params = {}) {
    const [pathname, queryStr] = url.split('?');
    let tempQuery = Utils.filterMerge(Object.assign({}, Utils.params2json(queryStr), Utils.filterMerge(Object.assign({}, params))));
    let searchQuery = Utils.formatQuery2QueryStr(tempQuery);
    return `${pathname}${searchQuery}`;
  },
  // 权限管理处理数据信息
  handleDataInfo(data = [], type = 1) {
    let list = [];
    if(type === 1) {
      data.forEach(item => {
        const infoFirst = {};
        infoFirst.title = item.name;
        infoFirst.key = item.id;
        if(item.childList && item.childList.length > 0) {
          infoFirst.children = [];
          item.childList.forEach(v => {
            const infoTwo = {};
            infoTwo.title = v.name;
            infoTwo.key = v.id;
            infoFirst.children.push(infoTwo);
          });
        }
        list.push(infoFirst);
      });
    } else {
      data.forEach(item => {
        list.push(item.id);
        if(item.childList && item.childList.length > 0) {
          item.childList.forEach(v => {
            list.push(v.id);
          });
        }
      });
    }
    return list;
  },
  getDate(time) {
    if(time && !(+time > 0)) {
      let [tDate, tTime] = time.split(' ');
      tDate = tDate.replace(/[^\d]/g, '/');
      time = tTime ? `${tDate} ${tTime}` : `${tDate}`;
    }
    const d = time ? new Date(time) : new Date();
    const M = d.getMonth() + 1;
    const D = d.getDate();
    const h = d.getHours();
    const m = d.getMinutes();
    const s = d.getSeconds();
    return {
      Y: d.getFullYear(),
      M: M < 10 ? '0' + M : M,
      W: d.getDay(), //周几
      D: D < 10 ? '0' + D : D,
      h: h < 10 ? '0' + h : h,
      min: m < 10 ? '0' + m : m,
      s: s < 10 ? '0' + s : s,
      ms: d.getMilliseconds()
    };
  },
  getSizeByByte(size) {
    if(typeof size !== 'number') {
      size = Number(size);
      // throw Error("Argument Must Be A Number")
    }
    const KBUNIT = 'KB', MBUNIT = 'M', UNITSIZE = 1024;
    let kb = size / UNITSIZE,
      mb = size / (UNITSIZE * UNITSIZE);
    return mb > 0.01
      ? parseFloat(mb).toFixed(2) + MBUNIT
      : parseFloat(kb).toFixed(2) + KBUNIT;
    // return parseFloat(mb).toFixed(2) + MBUNIT;
  },
  /**
   * 三位数内的阿拉伯数字转换
   * @param num
   * @returns {string}
   */
  numberConvertToUppercase(num) {
    num = Number(num);
    let upperCaseNumber = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '百', '千', '万', '亿'];
    let length = String(num).length;
    if(length === 1) {
      return upperCaseNumber[num];
    } else if(length === 2) {
      if(num === 10) {
        return upperCaseNumber[num];
      } else if(num > 10 && num < 20) {
        return '十' + upperCaseNumber[String(num).charAt(1)];
      } else {
        return upperCaseNumber[String(num).charAt(0)] + '十' + upperCaseNumber[String(num).charAt(1)].replace('零', '');
      }
    }
  },

  checkISBN10(code) {
    code = String(code).replace(/[-\s]/g, '');
    if(!/^\d{9}[\dxX]?$/.test(code)) {
      return '';
    }
    let i = 0,
      c = 0;
    for(; i < 9;) {
      c += code.charAt(i++) * i;
    }
    c %= 11;
    if(c === 10) {
      c = -1;
    }
    i = code.charAt(9);
    if(i === 'x' && c === -1) {
      return code;
    } else if(c !== -1 && Number(c) === Number(i)) {
      return code;
    } else {
      return '';
    }
  },

  checkISBN13(code) {
    code = String(code).replace(/[-\s]/g, '');
    if(!/^\d{12,13}$/.test(code)) {
      return '';
    }
    let i = 1,
      c = 0;
    for(; i < 12; i += 2) {
      c += Math.floor(code.charAt(i));
    }
    for(c *= 3, i = 0; i < 12; i += 2) {
      c += Math.floor(code.charAt(i));
    }
    c = (220 - c) % 10;
    return Number(c) === Number(code.charAt(12)) ? code : '';
  },

  checkISSN(code) {
    return Number(code) > 0 && code.length < 14 && code.length > 7;
  },

  checkCN(code) {
    code = String(code).replace(/[-\s]/g, '');
    if(code.indexOf('/') > -1) {
      code = code.split('/')[0];
    }
    if(code.length !== 6) {
      return '';
    }
    return code;
    //return code.charAt(0) === 'C' && code.charAt(1) === 'N' ? code : '';
  },

  // 配置二维码扫码链接
  getAppUrl(itemType, id, basePath, commonQuerys, sceneCode) {
    let middlePath = '';
    if(itemType === 'KK') {
      return `*kk${basePath}A${id}/questionnaire${commonQuerys}`;
    } else if(
      itemType === 'LIVE' ||
        itemType === 'LIVE_TIMETABLE' ||
        itemType === 'SCHEDULE'
    ) {
      // return `${basePath}application/${id}/live${commonQuerys}`;
      return `*live${basePath}A${id}/liveinfo${commonQuerys}`;
    } else if(itemType === 'ACTIVITY') {
      return `${basePath}application/${id}/propaganda${commonQuerys}`;
    } else if(itemType === 'NAIRE' || itemType === 'DA') {
      return `*qn${basePath}A${id}/list${commonQuerys}`;
    } else if(itemType === 'SPECIAL') {
      return `*st${basePath}A${id}/special${commonQuerys}`;
    } else if(itemType === 'VOTE') {
      return `*vt${basePath}A${id}/${Date.now()}/list${commonQuerys}`;
    } else if(itemType === 'BM') {
      return `*mt${basePath}A${id}/summary${commonQuerys}`;
    } else if(itemType === 'RECITE_WORD') {
      switch (sceneCode) {
        //消消乐
        case 'LINK':
          middlePath = 'blocks';
          break;
        default:
          middlePath = 'list';
      }
      return `*wd${basePath}A${id}/${middlePath}${commonQuerys}`;
    } else if(itemType === 'EF') {
      return `*tb${basePath}A${id}/list${commonQuerys}`;
    } else if(itemType === 'TUTOR') {
      return `*cc${basePath}A${id}/list${commonQuerys}`;
    } else if(itemType === 'ITEM_BANK') {
      return `*pretest${basePath}A${id}/list${commonQuerys}`;
    } else if(itemType === 'GROUP') {
      return `*group${basePath}A${id}/info${commonQuerys}`;
    } else if(itemType === 'ZSCORE') {
      return `*zscore${basePath}A${id}/search${commonQuerys}`;
    } else if(itemType === 'VOICE_MSG') {
      return `${basePath}application/${id}/voicemail${commonQuerys}`;
    } else if(itemType === 'BOOKCARD') {
      return `*card${basePath}A${id}/home${commonQuerys}`;
    } else if(itemType === 'INTERACT') {
      return `*interact${basePath}A${id}/home${commonQuerys}`;
    } else if(itemType === 'CLOCK') {
      return `*clock${basePath}A${id}/custom/sign${commonQuerys}`;
    } else if(itemType === 'AUDIO_MAGIC') {
      return `*magic${basePath}A${id}/box${commonQuerys}`;
    } else if(itemType === 'COURSE_WARE') {
      return `*cw${basePath}A${id}/list${commonQuerys}`;
    } else if(itemType === 'WORD_DICTATION') {
      return `*dictation${basePath}A${id}/list${commonQuerys}`;
    } else if(itemType === 'MATCH_LISTEN') {
      return `*mv${basePath}A${id}/listen${commonQuerys}`;
    } else if(itemType === 'ARTICLE_READING') {
      return `*ar${basePath}A${id}/reading${commonQuerys}`;
    } else if(itemType === 'ENGLISH_WALKMAN') {
      return `*wm${basePath}A${id}/player${commonQuerys}`;
    } else if(itemType === 'PBSTORY') {
      return `*pbstory${basePath}A${id}/list${commonQuerys}`;
    } else if(itemType === 'ORAL_EVALUATION') {
      return `*speak${basePath}A${id}/info${commonQuerys}`;
    } else if(itemType === 'TEST') {
      switch (sceneCode) {
        //属性测试
        case 'TEST_CHARACTER':
          middlePath = 'char';
          break;
          //知识测试
        case 'TEST_KNOWLEDGE':
          middlePath = 'know';
          break;
          //情感测试
        case 'TEST_EMOTION':
          middlePath = 'emotion';
          break;
        case 'TEST_ACTIVITY':
          middlePath = 'activity';
          break;
        case 'TEST_DIFFERENCE':
          middlePath = 'findDiff';
          break;
        case 'TEST_LOGIC':
          middlePath = 'gamebook';
          break;
        default:
          middlePath = 'char';
      }
      return `*tt${basePath}A${id}/${middlePath}/info${commonQuerys}`;
    } else if(itemType === 'WISH') {
      return `*wish${basePath}A${id}/home${commonQuerys}`;
    } else if(itemType === 'DRAW') {
      // 抽奖新类型
      let routeName = 'luckPage';
      if(sceneCode === 'TASK') {
        routeName = 'lucktask';
      }
      return `*luck${basePath}A${id}/${routeName}${commonQuerys}`;
    } else if(itemType === 'VIDEO') {
      return `${basePath}application/${id}/video${commonQuerys}`;
    } else if(itemType === 'EBOOK') {
      return `${basePath}application/${id}/ebook${commonQuerys}`;
    } else if(itemType === 'AUDIO') {
      switch (sceneCode) {
        // 绘本配乐
        case 'PAINTING':
          return `${basePath}application/${id}/audio/painting${commonQuerys}`;
          // 绘本配乐
        case 'LISTEN':
          return `${basePath}application/${id}/audio/listen${commonQuerys}`;
          // 绘本配乐
        case 'LESSON':
          return `${basePath}application/${id}/audio/lesson${commonQuerys}`;
        default:
          return `${basePath}application/${id}/audio${commonQuerys ? `${commonQuerys}&` : '?'}appType=${itemType}`;
      }
    } else if(itemType === 'TEACH_RESOURCE') {
      return `*tr${basePath}A${id}/packagelist${commonQuerys}`;
    } else if(itemType === 'TEST_PAPER') {
      return `${basePath}application/${id}/testpaper/paperList/${commonQuerys}`;
    } else if(itemType === 'STROKE_ORDER') {
      return `*pen${basePath}A${id}/list${commonQuerys}`;
    } else if(itemType === 'MEMBER') {
      return `*member${basePath}A${id}/info${commonQuerys}`;
    } else if(itemType === 'SUBJECTNOTE') {
      return `*subject${basePath}A${id}${commonQuerys}`;
    } else if(itemType === 'BOOK_CLICK') {
      return `*clickread${basePath}A${id}/home${commonQuerys}`;
    } else if(itemType === 'FLAG') {
      return `*flag${basePath}A${id}/entryFlag/start${commonQuerys}`;
    } else if(itemType === 'COLD_KNOWLEDGE') {
      return `*cold${basePath}A${id}/entryCold/start${commonQuerys}`;
    } else if(itemType === 'TICKET') {
      return `*aticket${basePath}A${id}/ticketHome${commonQuerys}`;
    } else if(itemType === 'FOREIGN_READ') {
      return `*getti${basePath}A${id}/gettiHome${commonQuerys}`;
    } else if(itemType === 'BOOK_ORDER') {
      return `${basePath}application/${id}/bookOrder${commonQuerys}`;
    } else if(itemType === 'WORD_LINK') {
      return `*eliminate${basePath}A${id}/home${commonQuerys}`;
    } else if(BAN_DU_APP.includes(itemType)) {
      return `/rayh5/applet?type=${itemType}`;
    } else if(itemType === 'LEARNING_REPORT') {
      return `/rayh5/learning/study${commonQuerys}`;
    } else if(itemType === 'MEMBER_ACTIVITY') {
      return `/rayh5/member/detail${commonQuerys ? commonQuerys + '&' : '?'}activityId=${id}`;
    } else if(itemType === 'JIGSAW') {
      return `*jigsaw${basePath}A${id}/${middlePath}home${commonQuerys}`;
    } else if(itemType === 'POSTGRADUATE_CALC') {
      return `*ky${basePath}A${id}/home${commonQuerys}`;
    } else if(itemType === 'GRAFFITI') {
      return `*graffiti${basePath}A${id}/${middlePath}home${commonQuerys}`;
    } else if(itemType === 'PIXEL_PAINTING') {
      return `*pixel${basePath}A${id}/${middlePath}home${commonQuerys}`;
    } else if(itemType === 'MOUNTING_MASTER') {
      return `*rahmen${basePath}A${id}/home${commonQuerys}`;
    } else if(itemType === 'EN_CH_DICTIONARY') {
      basePath = basePath.includes('W') ? '/W23' : '';
      return `*dictionary${basePath}/translation${commonQuerys}`;
    } else if(itemType === 'EN_WRITING_TEMPLATE') {
      basePath = basePath.includes('W') ? '/W23' : '';
      return `*write${basePath}/home${commonQuerys}`;
    } else if(itemType === 'CLASS_TOOL') {
      return `*classtool${basePath}A${id}/home${commonQuerys}`;
    } else if(itemType === 'INTELLECT_RECITE') {
      return `*recite${basePath}A${id}/main${commonQuerys}`;
    } else if(itemType === 'CALLIGRAPHY_COPY') {
      return `*penman${basePath}A${id}/home${commonQuerys}`;
    } else if(itemType === 'FUNNY_PRACTICE') {
      return `*practice${basePath}A${id}/main${commonQuerys}`;
    } else if(itemType === 'COLLAGE') {
      return `*collage${basePath}A${id}/${middlePath}home${commonQuerys}`;
    } else if(itemType === 'ONLINE_EXAM') {
      basePath = basePath.includes('W') ? '/W23' : '';
      return `*paperline${basePath}/center${commonQuerys}`;
    } else if(itemType === 'LISTENING_TRAINING') {
      basePath = basePath.includes('W') ? '/W23' : '';
      return `*listentrain${basePath}/home${commonQuerys}`;
    } else if(itemType === 'HONOR_MEDAL') {
      basePath = basePath.includes('W') ? '/W23' : '';
      return `*medal${basePath}/my${commonQuerys}`;
    } else {
      return `${basePath}application/${id}/display${commonQuerys ? `${commonQuerys}&` : '?'}appType=${itemType}`;
    }
  },
  getProductUrl(itemType, id, basePath, commonQuerys) {
    const newTypes = NEW_PRODUCT_TYPES.map(v => v.typeCode);
    if(itemType === 'PRETEST') {
      return `*pretest${basePath}P${id}/list${commonQuerys}`;
    } else if(['LIVE', 'LIVE_TIMETABLE', 'SCHEDULE'].includes(itemType)) {
      return Utils.padQuery(`*live${basePath}A${id}/liveinfo${commonQuerys}`, {
        proType: 'SCHEDULE'
      });
    } else if(itemType === 'QA') {
      return `${basePath}application/-1/foranswer/select/${id}${commonQuerys}`;
    } else if(itemType === 'SUBJECTNOTE') {
      return `*subject${basePath}P${id}${commonQuerys}`;
    } else if(itemType === 'ATTENDANCE_TASK') {
      return `*clock${basePath}P${id}${commonQuerys}`;
    } else if(itemType === 'VIDEO_SCHEDULE') {
      return `${basePath}product/display/${id}/video/preview${commonQuerys}`;
    } else if(newTypes.includes(itemType)) {
      const item = NEW_PRODUCT_TYPES.find(v => v.typeCode === itemType);
      return `*${item.prefix}${basePath}P${id}/${item.suffix}${commonQuerys}`;
    } else {
      return `${basePath}product/display/${id}${commonQuerys}`;
    }
  },
  getResourceUrl(basePath, resourceId, commonQuerys) {
    return `${basePath}content/resource/${resourceId}${commonQuerys}`;
  },
  // 处理数据
  formatNumber(num, duration = 0, start = 0.8, fixedLength = 2, unit) {
    if(!num) {
      return '0';
    }
    let value = num || 0;
    if(num > 0 && num < 1e4) {
      value = <span className="formatNumber">
        <CountUp
          redraw={false}
          start={num * start}
          end={num}
          decimals={num % 1 === 0 ? 0 : fixedLength}
          duration={duration}
        />
        <span className="formatNumber-unit">{unit}</span>
      </span>;
    }
    if(num >= 1e4 && num < 1e8) {
      value = <span className="formatNumber">
        <CountUp
          redraw={false}
          start={(num / 1e4).toFixed(fixedLength) * start}
          end={(num / 1e4).toFixed(fixedLength)}
          decimals={fixedLength}
          duration={duration}
        />
        <span className="formatNumber-unit">{unit || '万'}</span></span>;
    } else if(num >= 1e8) {
      value = <span className="formatNumber">
        <CountUp
          redraw={false}
          start={(num / 1e8).toFixed(fixedLength) * start}
          end={(num / 1e8).toFixed(fixedLength)}
          decimals={fixedLength}
          duration={duration}
        />
        <span className="formatNumber-unit">{unit || '亿'}</span></span>;
    }
    return value;
  },
  formatTime(sd) {
    if(!sd) return '刚刚';
    const s = sd, m = Math.floor(s / 60),
      h = Math.floor(m / 60), d = Math.floor(h / 24), w = Math.floor(d / 7), month = Math.floor(d / 30), year = Math.floor(month / 12);
    if(s <= 0) {
      return '刚刚';
    }
    if(m < 1) {
      return `${s}秒前`;
    } else if(h < 1) {
      return `${m}分钟前`;
    } else if(d < 1) {
      return `${h}小时前`;
    } else if(d < 2) {
      return '昨天';
    } else if(w < 1) {
      return `${d}天前`;
    } else if(w < 10) {
      return `${w}周前`;
    } else if(month < 12) {
      return `${month}月前`;
    } else {
      return `${year}年前`;
    }
  },
  /** 深拷贝 */
  deepClone(data) {
    return JSON.parse(JSON.stringify(data));
  },
  previewOfficeByMS(fileUrl) {
    // https://www.microsoft.com/en-us/microsoft-365/blog/2013/04/10/office-web-viewer-view-office-documents-in-a-browser/
    window.open('//view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(fileUrl));
  },
  getShortFileName(text = '', ext, nameLen) {
    ext = ext?.toLowerCase();
    if(ext === 'word') {
      ext = text.endsWith('.doc') ? 'doc' : 'docx';
    }
    text = text.replace(new RegExp(`.${ext}$`, 'i'), '');
    // 判断字符是不是中文、标点
    const reg =  /[a-zA-Z0-9,.!@#$%^&*()_\+-=\[\]\{}\|]/;
    let len = 0;
    const maxLen = nameLen || 20;
    // 遍历字符串
    for(let i = 0; i < text.length; i++) {
      if(len > maxLen) {
        return text.substring(0, i - 1).trim() + '....' + ext;
      }
      // 如果是中文
      if(!reg.test(text[i])) {
        // 中文字符长度为2
        len += 2;
      } else {
        len += 1;
      }
    }
    return text + '.' + ext;
  },
  // 将url参数转化为对象
  urlParamsToObject(url) {
    url = new URL(url);
    const params = new URLSearchParams(url.search);
    const paramObj = {};
    for(let [key, value] of params) {
      paramObj[key] = decodeURIComponent(value);
    }
    return paramObj;
  }
};

export default Utils;

// 小睿伴读小程序
const BAN_DU_APP = [
  'PHOTOGRAPH',  //
  'AI_TIKU',
  'APPLET_CLOCK',
  'APPLET_QA',
  'APPLET_WORD',
  'CALCULATOR',
  'FUNCTIONAL_DIGRAPH',
  'BRAIN_GRAPH',
  'EXAM_PAPER',
  'ANCIENT_WORD',
  'IDIOM',
  'POETRY',
  'ARITHMETIC',
  'CORRECTION',
  'ANSWER_ANALYSIS'
];

// 鲁班工程-作品重定向到rays-apps项目
const NEW_PRODUCT_TYPES = [
  {
    typeCode: 'SPECIALITY_TEST_EVALUATION', // 作品唯一CODE
    prefix: 'evaluation', // 链接前缀
    suffix: 'main' // 首页链接后缀
  },
  {
    typeCode: 'EN_ORAL_EVALUATION',
    prefix: 'speak',
    suffix: 'info'
  }
];
